import {useRouteMatch} from "react-router-dom";
import { PdfReadySignal } from "./components/pdfReadySignal";
import {LaegekompetenceMeta} from "../../sharedmodels/kompetence/laegekompetenceMeta";
import {useEffect, useState} from "react";
import {Localizer} from "../../../infrastructure/localization/localizer";
import {EmblaIcon} from "../emblaIcon/emblaIcon";
import {NotatType} from "../../sharedmodels/notat/notatType";
import {BasicNotatModel} from "../../sharedmodels/notat/basicNotatModel";
import {ReactComponent as EyeIcon} from "../../../content/icons/eye-gray.svg";
import {LaegekompetenceStatusEnum} from "../../sharedmodels/kompetence/laegekompetenceStatusEnum";
import {
    UserProfileAvatar,
    UserProfileAvatarSizeEnum,
    UserProfileLayoutEnum
} from "../userProfileAvatar/userProfileAvatar";
import {sortKompetenceBySortOrder} from "../../utils";
import {UserProfileAvatarModel} from "../userProfileAvatar/userProfileAvatarModel";
import PdfComponent from "core/components/pdf/components/pdfComponent";
import {PdfKompetenceHeaderComponent} from "./pdfHeaders/pdfKompetenceHeaderComponent";
import {useFetchWithErrorHandlingPdf} from "./hooks/useFetchWithErrorHandlingPdf";
import useLogbogApi from "../../hooks/useLogbogApi";
import useStamdataApi from "../../hooks/useStamdataApi";
import {PdfKompetenceHeaderModel} from "./models/pdfKompetenceHeaderModel";
import { fetchKompetenceHeader } from "./helpers/pdfFetchers";
import NoteTextViewer from "core/componentsPage/notat/tekstNotat/noteTextViewer";
import React from "react";
import HtmlHeading from "../titels/HtmlHeadings";
import PdfRow from "./components/pdfRow";

export function KompetencerPdf() {
    const routeMatch = useRouteMatch();
    const routeParams = routeMatch.params as { brugerId: string, brugerMaalbeskrivelseId: string};

    const [laegeKompetencer, setLaegeKompetencer] = useState<LaegekompetenceMeta[]>();
    const [notater, setNotater] = useState<BasicNotatModel[]>();
    const [headerData, setHeaderData] = useState<PdfKompetenceHeaderModel>();
    const [dataLoaded, setDataLoaded] = useState(false);
    const setError = useFetchWithErrorHandlingPdf();

    const { notatApi, logbogLaegeKompetenceApi, logbogUserInfoApi } = useLogbogApi();
    const { stamdataMaalbeskrivelseApi, stamdataSpecialeApi } = useStamdataApi();

    useEffect(() => {
        const fetchData = async () => {
            const [kompetencer, notaterResponse, header] = await Promise.all([
                logbogLaegeKompetenceApi.getLaegekompetencerByBrugerId(routeParams.brugerId),
                notatApi.getNotaterByBrugerId(NotatType.Merit, routeParams.brugerId),
                fetchKompetenceHeader(routeParams.brugerId, routeParams.brugerMaalbeskrivelseId, { stamdataMaalbeskrivelseApi, stamdataSpecialeApi, logbogUserInfoApi }),
            ]);
            setLaegeKompetencer(sortKompetenceBySortOrder(kompetencer.filter(k => k.brugerMaalbeskrivelseId === routeParams.brugerMaalbeskrivelseId)));
            setNotater(notaterResponse);
            setHeaderData(header);
            setDataLoaded(true);
        };
        fetchData().catch(setError);
    }, [routeParams.brugerId, routeParams.brugerMaalbeskrivelseId]);

    return (
        <PdfComponent>
            {headerData &&
                <PdfKompetenceHeaderComponent
                    brugerId={routeParams.brugerId}
                    data={headerData}
                />
            }
            <PdfComponent.BlockItem className={"card shadow-none"}>
                <PdfComponent.CardHeader>
                    <PdfRow className="flex-fill padding-top-m padding-bottom-m" useFlex={false}>
                        <PdfRow.Col heading={HtmlHeading.H3} width={6}>{Localizer.global_kompetencer()}</PdfRow.Col>
                        <PdfRow.Col heading={HtmlHeading.H3} width={2}>{Localizer.global_status()}</PdfRow.Col>
                        <PdfRow.Col heading={HtmlHeading.H3} width={4}>{Localizer.global_godkendtAf()}</PdfRow.Col>
                    </PdfRow>
                </PdfComponent.CardHeader>
                <PdfComponent.CardBody additionalClasses="padding-top-0">
                    <div className={"card-list-modal"}>
                        {laegeKompetencer?.map((laegekompetence, index) =>
                            <React.Fragment key={index}>
                                <PdfComponent.NonBreakableItem key={index}>
                                    <PdfRow useFlex={false} alignTop={false} className="margin-top-s margin-bottom-s">
                                        <PdfRow.Col width={6} className={"flex-align-c"}>
                                            <div className="flex-row">
                                                <div className="subtle">
                                                    {laegekompetence.kompetenceNummer}
                                                </div>
                                                <div className="subtle">
                                                    {laegekompetence.fullKompetenceTitle}
                                                </div>
                                            </div>
                                        </PdfRow.Col>
                                        <PdfRow.Col width={2} className={"flex-align-c"}>
                                            {laegekompetence.godkendtDato &&
                                                <>
                                                    {laegekompetence.meritNotat !== null &&
                                                        <div className={"flex-row"}>
                                                            <div>{Localizer.godkendtMedMeritDen() +": "}</div>
                                                            <div>{new Date(laegekompetence.godkendtDato).dateWithTimeFormat()}</div>
                                                            <div>{laegekompetence.meritNotat}</div>
                                                        </div>
                                                    }
                                                    {laegekompetence.meritNotat === null &&
                                                        <div className={"flex-row"}>
                                                            <div>{Localizer.godkendtDen() +": "}</div>
                                                            <div>{new Date(laegekompetence.godkendtDato).dateWithTimeFormat()}</div>
                                                        </div>
                                                    }

                                                </>

                                            }
                                            {!laegekompetence.godkendtDato && laegekompetence.status !== LaegekompetenceStatusEnum.Klarmeldt &&
                                                <>{Localizer.global_ikkeGodkendt()}</>
                                            }
                                            {laegekompetence.status === LaegekompetenceStatusEnum.Klarmeldt &&
                                                <>{Localizer.global_klarmeldt()}</>
                                            }
                                        </PdfRow.Col>
                                        <PdfRow.Col width={4} className={"flex-align-c"}>
                                            {laegekompetence.godkendtAfNavn &&
                                                <div>
                                                    {`${Localizer.global_name()}: ${laegekompetence.godkendtAfNavn}`}

                                                    {laegekompetence.godkendtAfAuthId &&
                                                        <div className={"flex-container"}>
                                                            <div className={"padding-right-xs"}>{`${Localizer.global_authorisationId()}:`}</div>
                                                            <div>{laegekompetence.godkendtAfAuthId}</div>
                                                        </div>
                                                    }
                                                    <div className={"flex-container"}>
                                                        <div className={"padding-right-xs"}>{`${Localizer.rolle()}:`}</div>
                                                        <div>{laegekompetence.godkendtAfRolleTitel}</div>
                                                    </div>
                                                </div>
                                            }
                                        </PdfRow.Col>
                                    </PdfRow>
                                </PdfComponent.NonBreakableItem>
                                <div className={"card-list-border"}/>
                            </React.Fragment>
                        )}
                    </div>
                </PdfComponent.CardBody>
            </PdfComponent.BlockItem>

            {notater && notater.length > 0 && <PdfComponent.PageBreak/>}

            {(notater && notater.length > 0) &&
                notater.filter(n => n.type === NotatType.Merit).map(notat =>
                    <PdfComponent.BlockItem key={notat.id} className={"card shadow-none"}>
                        <PdfComponent.CardBody>
                            <div className={"margin-l"}>
                                <div>
                                    <h5>{notat.title}</h5>
                                </div>

                                <NoteTextViewer
                                    id={notat.id}
                                    type={notat.type}
                                    text={notat.description}
                                />

                                <div className='w-50 margin-bottom-m margin-top-m'>
                                </div>
                                <div className='subtle d-flex flex-row'>
                                    <div className='d-flex flex-row margin-right-m'>
                                        <EmblaIcon iconName='calendar'/>
                                        <p className='margin-left-xs'>{notat.createdAt.dateAndTimeToApiPostFormat()}</p>
                                    </div>
                                    <>
                                        <UserProfileAvatar size={UserProfileAvatarSizeEnum.extraSmall}
                                                           userProfileAvatarModel={new UserProfileAvatarModel(notat.createdById, notat.createdByName, notat.createdByInitials, false)}
                                                           userProfileLayoutEnum={UserProfileLayoutEnum.AsTextOnRightSide}/>
                                    </>

                                    {notat.isPrivate &&
                                        <div className='d-flex flex-row margin-left-m'>
                                            <span><EyeIcon/></span>
                                            <p className='margin-left-xs'>{Localizer.global_private()}</p>
                                        </div>
                                    }
                                </div>
                            </div>
                        </PdfComponent.CardBody>
                    </PdfComponent.BlockItem>
                )
            }
            <PdfReadySignal when={dataLoaded} />
        </PdfComponent>
    );
}
